// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1vOKb","header":"PatientQuestionnaire_header__2qbeD","info":"PatientQuestionnaire_info__34n9o"};